<template>
  <BittsTooltip
    v-if="tooltipData"
    :placement="placement"
    :mount-to-body="true"
    :auto-adjust-overflow="true"
    :align="{ offset: [16, 0] }"
    class="c-preset-fields-tooltip"
  >
    <template #title>
      <div v-if="presetName" class="c-preset-fields-tooltip__name">
        {{ presetName }}
      </div>
      <div v-for="source in tooltipData" :key="source.tableName" class="mb-8">
        <div class="font-bold mb-4">{{ source.tableName }}</div>
        <div class="flex flex-wrap gap-4">
          <BittsTag
            v-for="field in source.fields"
            :key="`field__${field.id}`"
            size="x-small"
            color="field-tooltip"
            :text="field.display_name"
          />
        </div>
      </div>
    </template>
    <slot />
  </BittsTooltip>
  <slot v-else />
</template>

<script setup lang="ts">
import { BittsTag, BittsTooltip } from '@crossbeam/bitts';
import type { PlacementType } from '@crossbeam/bitts';

type TooltipData = {
  tableName: string;
  fields: { id: number; display_name: string }[];
}[];

withDefaults(
  defineProps<{
    tooltipData: TooltipData | null;
    placement?: PlacementType;
    presetName?: string;
  }>(),
  {
    placement: 'right',
    presetName: undefined,
  },
);
</script>

<style lang="pcss">
@reference "../../css/theme.css";

.c-preset-fields-tooltip {
  @apply block w-full;
}

.c-preset-fields-tooltip__name {
  @apply font-bold mb-8 pb-8 border-b border-neutral-background-weak/12 break-words;
}

.field-tooltip {
  @apply bg-neutral-background-weak/12 text-neutral-background-weak;
}
</style>
